import { render, staticRenderFns } from "./DiceOverlay.vue?vue&type=template&id=61a3b2eb&scoped=true"
import script from "./DiceOverlay.vue?vue&type=script&lang=js"
export * from "./DiceOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a3b2eb",
  null
  
)

export default component.exports